<div #postListContainer class="post-list"
     [style.maxHeight]="height"
     [style.overflow]="overflow" *ngIf="postList.length > 0">
<div #popupcontainer class="popup-card-hover-container"
       id="popupcontainer"
       (panend)="hidePopupCardHover()"
       (clickOutside)="hidePopupCardHover($event)"
       (mouseleave)="hidePopupCardHover()">
    <div #popup class="popup-card-hover post-content" [class.d-none]="!openPreviewPostPopup" id="popup">
      <influencer-overview-post-content *ngIf="openPreviewPostPopup"
                                        [influencerGroupId]="influencerGroupId"
                                        postId="{{'masonry-item-' + i}}"
                                        [item]="activePost"
                                        [target]="target"
                                        [previewMode]="previewMode"
                                        (closePopupCardHover)="hidePopupCardHover()"
                                        (selectedPost)="onSelectedPost($event)"
                                        [displayMode]="displayMode">
      </influencer-overview-post-content>

    </div>
  </div>
  <!-- Masonry grid Container -->
  <ng-masonry-grid
    [masonryOptions]="{columnWidth: '.grid-item', gutter: gutter, horizontalOrder: true, stagger: 0, transitionDuration: 0}"
    [useAnimation]="false"
    (onNgMasonryInit)="onNgMasonryInit($event)"
    (layoutComplete)="layoutComplete($event)">
    <!-- Masonry Grid Item -->
    <ng-masonry-grid-item
      id="{{'masonry-item-'+i}}"
      class="grid-item"
      *ngFor="let item of postList; trackBy: trackByFn; let i = index; "
      (panstart)="onMouseHover($event, 'masonry-item-' + i, item)"
      (mouseenter)="onMouseHover($event, 'masonry-item-' + i, item)" >
      <!-- Grid Content  -->
      <post-image [post]="item"></post-image>
    </ng-masonry-grid-item>
  </ng-masonry-grid>

</div>
<div class="fade-out-content" *ngIf="postList && height!=='max-content' && !previewMode"></div>
<div class="buttons text-center" *ngIf="postList && height!=='max-content' && !previewMode">
  <button class="button blue show-more-btn" (click)="showMore()">{{ 'INFLUENCER.overview.show_more' | translate }}</button>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/post-list/post-list.component.html